import SkeletonCircle from 'conversations-skeleton-state/components/SkeletonCircle';
import VizExAvatar from 'visitor-ui-component-library/avatar/VizExAvatar';
// @ts-ignore Untyped Dependency
import { getSenderTypeForCMF } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import { getAvatar, getDisplayName } from 'conversations-message-history/senders/operators/getters';
import { useMrHubBot } from 'conversations-message-history/constants/images';
import { BOT, SYSTEM } from 'conversations-message-history/common-message-format/constants/legacySenderTypes';
import I18n from 'I18n';
// @ts-ignore Untyped import
import aiAvatar from 'bender-url!../../img/ai-avatar.png';
import { jsx as _jsx } from "react/jsx-runtime";
function SenderAvatar({
  isLoading,
  isResponderAI = false,
  onClick,
  sender,
  size = 'sm'
}) {
  const mrHubBot = useMrHubBot();
  if (isLoading) return /*#__PURE__*/_jsx(SkeletonCircle, {
    size: 32
  });
  if (!sender) return /*#__PURE__*/_jsx(VizExAvatar, {
    alt: "",
    size: size
  });
  const senderType = getSenderTypeForCMF(sender);
  const defaultAgentName = I18n.text('conversations-visitor-message-history.agent');
  const altText = I18n.text('conversations-visitor-message-history.avatar', {
    identifier: getDisplayName(sender, I18n.text('conversations-visitor-message-history.unknownVisitor')) || defaultAgentName
  });
  switch (senderType) {
    case BOT:
    case SYSTEM:
      return /*#__PURE__*/_jsx(VizExAvatar, {
        size: size,
        src: getAvatar(sender) || mrHubBot,
        alt: altText
      });
    default:
      return /*#__PURE__*/_jsx("span", {
        onClick: () => onClick === null || onClick === void 0 ? void 0 : onClick(sender),
        children: /*#__PURE__*/_jsx(VizExAvatar, {
          size: size,
          src: getAvatar(sender) || (isResponderAI ? aiAvatar : undefined),
          alt: altText
        })
      });
  }
}
SenderAvatar.displayName = 'SenderAvatar';
export default SenderAvatar;